// Gatsby requirements
import React from "react"

// Styles
import * as CSS from './starRating.module.scss'

const StarRating = ({ rating, className }) => {

    return (
        <div className={`${CSS.rating} ${className}`}>
            <div className={CSS.starRating}>
                <img
                    src="/icons/star-rating-empty.svg"
                    className={`${CSS.emptyStarRating}`}
                    loading="lazy"
                    aria-hidden="true"
                    width="106"
                    height="17"
                    alt=""
                />
                <img
                    src="/icons/star-rating.svg"
                    className={`
                        ${rating > 8 && rating <= 9 && CSS.rating45}
                        ${rating > 7 && rating <= 8 && CSS.rating4}
                        ${rating > 6 && rating <= 7 && CSS.rating35}
                        ${rating > 5 && rating <= 6 && CSS.rating3}
                        ${rating > 4 && rating <= 5 && CSS.rating25}
                        ${rating > 3 && rating <= 4 && CSS.rating2}
                        ${rating > 2 && rating <= 3 && CSS.rating15}
                        ${rating <= 2 && CSS.rating1}
                    `}
                    loading="lazy"
                    width="106"
                    height="17"
                    alt={`Star rating: ${rating.replace('.', ',')}`}
                />
            </div>
            <span aria-hidden="true">{rating.replace('.', ',')}</span>
        </div>
    )
}

export default StarRating